import { Component, Inject, OnInit, effect, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import {
  DiscountPlace,
  GetEnumValuesDto,
  PrivateNumberPricesWithPaginationForUserDto,
} from 'src/app/core/api/models';
import {
  DiscountService,
  PrivateNumberBuyRequestService,
} from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import { DynamicTabService } from 'src/app/core/services/dynamic-tab.service';
import { BaseFormPageComponent } from 'src/app/pages/shared/base/components/base-form-page.component';
import { VerifyDiscountResult } from 'src/app/shared/components/verify-discount-input/verify-discount-input.component';
import { CreatePrivateNumberBuyRequestCommand } from '../../../../core/api/models/create-private-number-buy-request-command';
import { AppStateService } from '../../../../core/services/app-state.service';
import { LocalPrivateNumberPriceService } from '../../shared/local-private-number-price.service';

@Component({
    selector: 'private-numbers-price-for-user-form.component',
    templateUrl: './private-numbers-price-for-user-form.component.html',
    styleUrls: ['./private-numbers-price-for-user-form.component.scss'],
    standalone: false
})
export class PrivateNumberPriceForUserFormComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region properties
  appStateService = inject(AppStateService);

  model: CreatePrivateNumberBuyRequestCommand = {};
  privateNumberPrice: PrivateNumberPricesWithPaginationForUserDto;
  SmsCpEnumValues: GetEnumValuesDto[] = [];
  vocabsPatch: string;

  discountAmount: number = 0;
  discountCode: string;
  organizationCredit: number;
  finalAmount: number;
  isConfirm: boolean = false;
  discountLoading: boolean = false;
  isSuccessPurchase: boolean = false;
  verifyDescription: string = '';
  get DiscountPlace() {
    return DiscountPlace;
  }

  //#endregion

  constructor(
    protected currentService: PrivateNumberBuyRequestService,
    protected discountService: DiscountService,
    private dynamicTabService: DynamicTabService,

    private dialogRef: MatDialogRef<PrivateNumberPriceForUserFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super();
    this.privateNumberPrice = data.privateNumberPrice;
    this.SmsCpEnumValues = data.SmsCpEnumValues;
    this.formPageConfig.vocabs = data.vocabsPatch;

    effect(() => {
      this.organizationCredit = this.appStateService.organizationCredit();
    });
  }

  ngOnInit(): void {
    try {
      this.getVocabs();
      this.initForm();

      this.finalAmount = this.privateNumberPrice.price;
      this.model.privateNumberPriceId = this.privateNumberPrice.id;
    } catch (error) {
      this.loggerService?.logError(
        this.tagName,
        error,
        EventTypes.privateNumberPrice
      );
    }
  }

  initForm(): void {
    this.form = new FormGroup({
      number: new FormControl('', [
        Validators.required,
        Validators.maxLength(this.privateNumberPrice.numberOfDigits),
      ]),
      discountCode: new FormControl(''),
      isConfirm: new FormControl(''),
    });
  }

  //#region Api

  //Create
  baseCreateApi(model: CreatePrivateNumberBuyRequestCommand) {
    this.unSubs();
    this.loading = true;

    this.currentService
      .privateNumberBuyRequestCreatePost({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe((result) => {
        if (result.isSucceed) {
          this.isSuccessPurchase = true;
          LocalPrivateNumberPriceService.privateNumberBuyRequestId =
            +result.data;
        }
        if (!result.isSucceed)
          this.apiNotificationService.notifyMessage({ result });
      });
  }

  //#endregion

  onSubmit() {
    if (this.discountAmount) this.model.discountCode = this.discountCode;
    else this.model.discountCode = '';
    super.onSubmit();
  }

  onClose() {
    this.dialogRef.close(false);
  }

  onSuccess() {
    this.dialogRef.close(true);
  }

  openIncreaseCredit() {
    try {
      this.onClose();
      this.dynamicTabService.setNewTab('');
      this.dynamicTabService.setNewTab('newPayment');
      this.dynamicTabService.setActiveTab('newPayment');
    } catch (error) {
      this.loggerService?.logError(
        this.tagName,
        error,
        EventTypes.privateNumberPrice
      );
    }
  }

  getVerifyDiscountResult(result: VerifyDiscountResult) {
    if (result?.discountAmount && result?.verifyStatus) {
      this.discountAmount = result.discountAmount;
      this.finalAmount = result.priceAfterDiscount;
      this.discountCode = result.discountCode;
    } else {
      this.discountAmount = 0;
      this.finalAmount = this.privateNumberPrice?.price;
      this.discountCode = '';
    }
  }
}
